import { CountUp } from 'countup.js';
import 'waypoints/lib/noframework.waypoints.min.js';

// Reset stats to 0
document.addEventListener("DOMContentLoaded", function() {
  document.querySelectorAll('.stats__highlight').forEach( (item) => {
      item.innerHTML = 0;
  });
});

function countStart(){
    const counters = document.querySelectorAll('.stats__highlight'),
    options = {
      useEasing : true,
      useGrouping : false,
      separator : ',',
      decimal : '.',
      prefix : '',
      suffix : ''
    };

    counters.forEach( (item) => {
        const value = item.dataset.value;
        const counter = new CountUp(item, value, options);
        counter.start();
    });
}

const statsElement = document.querySelector('.stats');
if (statsElement) {
  new Waypoint({
    element: statsElement,
    handler: function() {
        countStart()
        this.destroy()
    },
    offset: '75%'
  });
}
